import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    updateQuestionnaireAnswers,
    uploadQuestionnaireFile,
    deleteQuestionnaireFile
} from '../../VendorsApis';

export const useQuestionnaireActions = (questionnaireId) => {
    const queryClient = useQueryClient();
    const invalidate = () => queryClient.invalidateQueries(['questions', questionnaireId]);

    const updateAnswer = useMutation({
        mutationFn: ({ auditId, action, payload }) => updateQuestionnaireAnswers(questionnaireId, auditId, action, payload),
        onSuccess: invalidate
    });

    const uploadFile = useMutation({
        mutationFn: (payload) => uploadQuestionnaireFile(payload), // الـ payload هنا هو الـ object اللي فيه "files"
        onSuccess: () => {
            queryClient.invalidateQueries(['questions', questionnaireId]);
        }
    });

    const deleteFile = useMutation({
        mutationFn: (docId) => deleteQuestionnaireFile(docId),
        onSuccess: () => {
            // بنعمل invalidate عشان الداتا تتحدث بعد المسح
            queryClient.invalidateQueries(['questions', questionnaireId]);
        }
    });



    return {
        submitAnswer: updateAnswer.mutate,
        isUpdating: updateAnswer.isLoading,
        uploadFile: uploadFile.mutate,
        isUploading: uploadFile.isLoading,
        deleteFile: deleteFile.mutateAsync,
        isAnyActionLoading: updateAnswer.isPending || uploadFile.isPending
    };
};